'use client';

import a__default, { forwardRef } from "react";
import b from "../lib/IconBase.js";
import t$1 from "../defs/CheckCircle.js";
var i = Object.defineProperty, f = Object.defineProperties;
var p = Object.getOwnPropertyDescriptors;
var t = Object.getOwnPropertySymbols;
var s = Object.prototype.hasOwnProperty, l = Object.prototype.propertyIsEnumerable;
var c = (r, e, o) => e in r ? i(r, e, { enumerable: true, configurable: true, writable: true, value: o }) : r[e] = o, m = (r, e) => {
  for (var o in e || (e = {}))
    s.call(e, o) && c(r, o, e[o]);
  if (t)
    for (var o of t(e))
      l.call(e, o) && c(r, o, e[o]);
  return r;
}, a = (r, e) => f(r, p(e));
const k = forwardRef((r, e) => /* @__PURE__ */ a__default.createElement(b, a(m({ ref: e }, r), { weights: t$1 })));
k.displayName = "CheckCircle";
export {
  k as CheckCircle
};
